<section class="page cover" style="background: url(assets/cover.jpg) no-repeat;background-size: cover;">
    <div class="container">
        <div class="coverContent align--middle">
            <div class="coverContent__title">
                Westest Java’s Leading Briquette & Palm Sugar
            </div>
            <div class="coverContent__lead">
                Mesona Green is the leading specifically briquette and palm sugar exporter based in the very west of java island. We not only offer the best quality but also customized order fullfilling your needs
            </div>
        </div>
    </div>
</section>
<section class="page product">
    <h2 class="heading">Products</h2>
    <div class="container">
        <div class="page__desc">
            <p>Coconut Briquette Charcoal – Palm Sugar</p>
        </div>
        <div class="product__list product__list1 dmt70">
            <div class="card" *ngFor="let pd of products">
                <div class="card__header">
                    <img src="{{pd.image}}">
                </div>
                <div class="card__content">
                    <h3>{{pd.title}}</h3>
                    <p>{{pd.description}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="page product">
    <h2 class="heading">Galerry</h2>
    <div class="container">
        <div class="page__desc">
            <p>Photo's soon</p>
        </div>
    </div>
</section>

<section class="page product">
    <h2 class="heading">Our Value</h2>
    <div class="container product__list">
        <div class="card" *ngFor="let pd of home">
            <div class="card__header">
                <img src="{{pd.image}}">
            </div>
            <div class="card__content">
                <h3>{{pd.title}}</h3>
                <p>{{pd.description}}</p>
            </div>
        </div>
    </div>
</section>
<section class="page team">
    <h2 class="heading">Our Team</h2>
    <div class="container team__list">
        <div class="card" *ngFor="let pd of team">
            <div class="card__header">
                <img src="{{pd.image}}">
            </div>
            <div class="card__content">
                <h3>{{pd.name}}</h3>
                <h4 class="card__subtitle">{{pd.title}}</h4>
                <p>Socmed list</p>
            </div>
        </div>
    </div>
</section>
<section class="page about">
    <h2 class="heading">About </h2>
    <div class="container">
        <div class="page__desc">
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Non illum doloremque hic deleniti numquam quidem odit minus eum magnam dolor provident inventore error, aut molestias aliquam quam! Ad, numquam nesciunt?</p>
        </div>
    </div>
</section>
